import { render, staticRenderFns } from "./cambiarCategoriaTareasExternas.vue?vue&type=template&id=2d1a5423"
import script from "./cambiarCategoriaTareasExternas.vue?vue&type=script&lang=js"
export * from "./cambiarCategoriaTareasExternas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports